import {
    createElementVNode as _$ce,
    noop as _$no,
    className as _$cn,
} from 'intact';
import {makeStyles} from './style';
import {kls} from './style';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {mode} = this.get();
    const {firstSize, lastSize} = this.size;
    const {firstRef, lastRef, elementRef, start, dragging} = this.drag;
    const classNameObj = {
        'k-split': true,
        [`k-${mode}`]: true,
        [makeStyles()]: true,
        ['k-first-auto']: firstSize.value === 'auto',
        ['k-last-auto']: lastSize.value === 'auto',
        ['k-resizing']: dragging.value,
    };
    
    const stylePropName = mode === 'horizontal' ? 'width' : 'height';
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', (
            (
                (_$blocks['first'] = function($super) {
                    return null;
                }),
                (__$blocks['first'] = function($super, data) {
                    var block = $blocks['first'];
                    var callBlock = function() {
                        return _$blocks['first'].call($this, $super, data);
                    };
                    return block ?
                        block.call($this, callBlock, data) :
                        callBlock();
                }),
                __$blocks['first'](_$no)
            )
        ), 0, _$cn(kls('first')), {
            'style': {[stylePropName]: firstSize.value}
        }, null, firstRef),
        _$ce(2, 'div', (
            (
                (_$blocks['drag'] = function($super) {
                    return (
                        _$ce(2, 'div', (
                            _$ce(2, 'div', null, 1, _$cn(kls('drag-lines')))
                        ), 2, _$cn(kls('line')))
                    );
                }),
                (__$blocks['drag'] = function($super, data) {
                    var block = $blocks['drag'];
                    var callBlock = function() {
                        return _$blocks['drag'].call($this, $super, data);
                    };
                    return block ?
                        block.call($this, callBlock, data) :
                        callBlock();
                }),
                __$blocks['drag'](_$no)
            )
        ), 0, _$cn(kls('line-wrapper')), {
            'ev-mousedown': start
        }),
        _$ce(2, 'div', (
            (
                (_$blocks['last'] = function($super) {
                    return null;
                }),
                (__$blocks['last'] = function($super, data) {
                    var block = $blocks['last'];
                    var callBlock = function() {
                        return _$blocks['last'].call($this, $super, data);
                    };
                    return block ?
                        block.call($this, callBlock, data) :
                        callBlock();
                }),
                __$blocks['last'](_$no)
            )
        ), 0, _$cn(kls('last')), {
            'style': {[stylePropName]: lastSize.value}
        }, null, lastRef)
    ], 4, _$cn(classNameObj), null, null, elementRef);
};